"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const stateHelper = __importStar(require("./state-helper"));
const core = __importStar(require("@actions/core"));
const actionsToolkit = __importStar(require("@docker/actions-toolkit"));
const buildx_1 = require("@docker/actions-toolkit/lib/buildx/buildx");
const history_1 = require("@docker/actions-toolkit/lib/buildx/history");
const context_1 = require("@docker/actions-toolkit/lib/context");
const docker_1 = require("@docker/actions-toolkit/lib/docker/docker");
const exec_1 = require("@docker/actions-toolkit/lib/exec");
const github_1 = require("@docker/actions-toolkit/lib/github");
const toolkit_1 = require("@docker/actions-toolkit/lib/toolkit");
const util_1 = require("@docker/actions-toolkit/lib/util");
const context = __importStar(require("./context"));
actionsToolkit.run(
// main
() => __awaiter(void 0, void 0, void 0, function* () {
    const startedTime = new Date();
    const inputs = yield context.getInputs();
    core.debug(`inputs: ${JSON.stringify(inputs)}`);
    stateHelper.setInputs(inputs);
    const toolkit = new toolkit_1.Toolkit();
    yield core.group(`GitHub Actions runtime token ACs`, () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield github_1.GitHub.printActionsRuntimeTokenACs();
        }
        catch (e) {
            core.warning(e.message);
        }
    }));
    yield core.group(`Docker info`, () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield docker_1.Docker.printVersion();
            yield docker_1.Docker.printInfo();
        }
        catch (e) {
            core.info(e.message);
        }
    }));
    yield core.group(`Proxy configuration`, () => __awaiter(void 0, void 0, void 0, function* () {
        let dockerConfig;
        let dockerConfigMalformed = false;
        try {
            dockerConfig = yield docker_1.Docker.configFile();
        }
        catch (e) {
            dockerConfigMalformed = true;
            core.warning(`Unable to parse config file ${path.join(docker_1.Docker.configDir, 'config.json')}: ${e}`);
        }
        if (dockerConfig && dockerConfig.proxies) {
            for (const host in dockerConfig.proxies) {
                let prefix = '';
                if (Object.keys(dockerConfig.proxies).length > 1) {
                    prefix = '  ';
                    core.info(host);
                }
                for (const key in dockerConfig.proxies[host]) {
                    core.info(`${prefix}${key}: ${dockerConfig.proxies[host][key]}`);
                }
            }
        }
        else if (!dockerConfigMalformed) {
            core.info('No proxy configuration found');
        }
    }));
    if (!(yield toolkit.buildx.isAvailable())) {
        core.setFailed(`Docker buildx is required. See https://github.com/docker/setup-buildx-action to set up buildx.`);
        return;
    }
    stateHelper.setTmpDir(context_1.Context.tmpDir());
    yield core.group(`Buildx version`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield toolkit.buildx.printVersion();
    }));
    let builder;
    yield core.group(`Builder info`, () => __awaiter(void 0, void 0, void 0, function* () {
        builder = yield toolkit.builder.inspect(inputs.builder);
        core.info(JSON.stringify(builder, null, 2));
    }));
    const args = yield context.getArgs(inputs, toolkit);
    core.debug(`context.getArgs: ${JSON.stringify(args)}`);
    const buildCmd = yield toolkit.buildx.getCommand(args);
    core.debug(`buildCmd.command: ${buildCmd.command}`);
    core.debug(`buildCmd.args: ${JSON.stringify(buildCmd.args)}`);
    let err;
    yield exec_1.Exec.getExecOutput(buildCmd.command, buildCmd.args, {
        ignoreReturnCode: true,
        env: Object.assign({}, process.env, {
            BUILDX_METADATA_WARNINGS: 'true'
        })
    }).then(res => {
        var _a, _b, _c;
        if (res.stderr.length > 0 && res.exitCode != 0) {
            err = Error(`buildx failed with: ${(_c = (_b = (_a = res.stderr.match(/(.*)\s*$/)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : 'unknown error'}`);
        }
    });
    const imageID = toolkit.buildxBuild.resolveImageID();
    const metadata = toolkit.buildxBuild.resolveMetadata();
    const digest = toolkit.buildxBuild.resolveDigest(metadata);
    if (imageID) {
        yield core.group(`ImageID`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(imageID);
            core.setOutput('imageid', imageID);
        }));
    }
    if (digest) {
        yield core.group(`Digest`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(digest);
            core.setOutput('digest', digest);
        }));
    }
    if (metadata) {
        yield core.group(`Metadata`, () => __awaiter(void 0, void 0, void 0, function* () {
            const metadatadt = JSON.stringify(metadata, null, 2);
            core.info(metadatadt);
            core.setOutput('metadata', metadatadt);
        }));
    }
    let ref;
    yield core.group(`Reference`, () => __awaiter(void 0, void 0, void 0, function* () {
        ref = yield buildRef(toolkit, startedTime, inputs.builder);
        if (ref) {
            core.info(ref);
            stateHelper.setBuildRef(ref);
        }
        else {
            core.info('No build reference found');
        }
    }));
    if (buildChecksAnnotationsEnabled()) {
        const warnings = toolkit.buildxBuild.resolveWarnings(metadata);
        if (ref && warnings && warnings.length > 0) {
            const annotations = yield buildx_1.Buildx.convertWarningsToGitHubAnnotations(warnings, [ref]);
            core.debug(`annotations: ${JSON.stringify(annotations, null, 2)}`);
            if (annotations && annotations.length > 0) {
                yield core.group(`Generating GitHub annotations (${annotations.length} build checks found)`, () => __awaiter(void 0, void 0, void 0, function* () {
                    for (const annotation of annotations) {
                        core.warning(annotation.message, annotation);
                    }
                }));
            }
        }
    }
    yield core.group(`Check build summary support`, () => __awaiter(void 0, void 0, void 0, function* () {
        if (!buildSummaryEnabled()) {
            core.info('Build summary disabled');
        }
        else if (github_1.GitHub.isGHES) {
            core.info('Build summary is not yet supported on GHES');
        }
        else if (!(yield toolkit.buildx.versionSatisfies('>=0.13.0'))) {
            core.info('Build summary requires Buildx >= 0.13.0');
        }
        else if (builder && builder.driver === 'cloud') {
            core.info('Build summary is not yet supported with Docker Build Cloud');
        }
        else if (!ref) {
            core.info('Build summary requires a build reference');
        }
        else {
            core.info('Build summary supported!');
            stateHelper.setSummarySupported();
        }
    }));
    if (err) {
        throw err;
    }
}), 
// post
() => __awaiter(void 0, void 0, void 0, function* () {
    if (stateHelper.isSummarySupported) {
        yield core.group(`Generating build summary`, () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const recordUploadEnabled = buildRecordUploadEnabled();
                let recordRetentionDays;
                if (recordUploadEnabled) {
                    recordRetentionDays = buildRecordRetentionDays();
                }
                const buildxHistory = new history_1.History();
                const exportRes = yield buildxHistory.export({
                    refs: stateHelper.buildRef ? [stateHelper.buildRef] : []
                });
                core.info(`Build record written to ${exportRes.dockerbuildFilename} (${util_1.Util.formatFileSize(exportRes.dockerbuildSize)})`);
                let uploadRes;
                if (recordUploadEnabled) {
                    uploadRes = yield github_1.GitHub.uploadArtifact({
                        filename: exportRes.dockerbuildFilename,
                        mimeType: 'application/gzip',
                        retentionDays: recordRetentionDays
                    });
                }
                yield github_1.GitHub.writeBuildSummary({
                    exportRes: exportRes,
                    uploadRes: uploadRes,
                    inputs: stateHelper.inputs
                });
            }
            catch (e) {
                core.warning(e.message);
            }
        }));
    }
    if (stateHelper.tmpDir.length > 0) {
        yield core.group(`Removing temp folder ${stateHelper.tmpDir}`, () => __awaiter(void 0, void 0, void 0, function* () {
            fs.rmSync(stateHelper.tmpDir, { recursive: true });
        }));
    }
}));
function buildRef(toolkit, since, builder) {
    return __awaiter(this, void 0, void 0, function* () {
        // get ref from metadata file
        const ref = toolkit.buildxBuild.resolveRef();
        if (ref) {
            return ref;
        }
        // otherwise, look for the very first build ref since the build has started
        if (!builder) {
            const currentBuilder = yield toolkit.builder.inspect();
            builder = currentBuilder.name;
        }
        const refs = buildx_1.Buildx.refs({
            dir: buildx_1.Buildx.refsDir,
            builderName: builder,
            since: since
        });
        return Object.keys(refs).length > 0 ? Object.keys(refs)[0] : '';
    });
}
function buildChecksAnnotationsEnabled() {
    if (process.env.DOCKER_BUILD_CHECKS_ANNOTATIONS) {
        return util_1.Util.parseBool(process.env.DOCKER_BUILD_CHECKS_ANNOTATIONS);
    }
    return true;
}
function buildSummaryEnabled() {
    if (process.env.DOCKER_BUILD_NO_SUMMARY) {
        core.warning('DOCKER_BUILD_NO_SUMMARY is deprecated. Set DOCKER_BUILD_SUMMARY to false instead.');
        return !util_1.Util.parseBool(process.env.DOCKER_BUILD_NO_SUMMARY);
    }
    else if (process.env.DOCKER_BUILD_SUMMARY) {
        return util_1.Util.parseBool(process.env.DOCKER_BUILD_SUMMARY);
    }
    return true;
}
function buildRecordUploadEnabled() {
    if (process.env.DOCKER_BUILD_RECORD_UPLOAD) {
        return util_1.Util.parseBool(process.env.DOCKER_BUILD_RECORD_UPLOAD);
    }
    return true;
}
function buildRecordRetentionDays() {
    let val;
    if (process.env.DOCKER_BUILD_EXPORT_RETENTION_DAYS) {
        core.warning('DOCKER_BUILD_EXPORT_RETENTION_DAYS is deprecated. Use DOCKER_BUILD_RECORD_RETENTION_DAYS instead.');
        val = process.env.DOCKER_BUILD_EXPORT_RETENTION_DAYS;
    }
    else if (process.env.DOCKER_BUILD_RECORD_RETENTION_DAYS) {
        val = process.env.DOCKER_BUILD_RECORD_RETENTION_DAYS;
    }
    if (val) {
        const res = parseInt(val);
        if (isNaN(res)) {
            throw Error(`Invalid build record retention days: ${val}`);
        }
        return res;
    }
}
